import React from "react";
import { AutoComplete } from 'primereact/autocomplete';
import useFormError from "../../hooks/useFormError";
import '../css/Form.css'

const ProAutoComplete = ({id, labelText, value, suggestions, completeMethod, onChange,  disabled=false,
        style={width: '100%', minHeight:'40px'}, headerText, field, minLength, required, multiple = true, formik = {}, error})=>{

        const getFormErrorMessage = useFormError(formik);
        const placeholderText = required?<label htmlFor="inputtext">{labelText}</label>
                                    : <label htmlFor="inputtext">{labelText}<span style={{fontSize:11}}>  (optional)</span></label>
    return (<div>
        <div className="p-field p-col-12">
            {
                headerText && 
                <div className="p-d-flex p-jc-start">
                <h6 className="form-header">{headerText}</h6>
            </div>
            }
            <span className="p-float-label p-fluid">
                <AutoComplete id={id}  multiple = {multiple}
                                field={field}
                                value={value}  
                                suggestions = {suggestions||[]}
                                completeMethod = {completeMethod}                                
                                minLength = {minLength}                         
                                onChange={onChange}
                                style={{...style}}
                                disabled = {disabled}
                            />               
                {placeholderText}
            </span>            
        </div>
        <div>
      {error && getFormErrorMessage && getFormErrorMessage(error)}
      </div>
        </div>)
}

export default ProAutoComplete;